import { BusinessFunction, BusinessUnit } from 'api-client';
import { Employee } from 'api-client/models/Employee';
import useSelector from 'hooks/useSelector';

import { appConfig } from '../appConfig';
import { useAdUser } from '../AuthContext';

export const PREVENT_SCROLLING = "prevent-scrolling";

export const getIsProd = () => appConfig.environment === "prod";

export function generateFeatureFlags(
    isProd: boolean,
    isAdmin: boolean,
    profile: Employee | undefined,
) {
    if (!isProd) {
        return {
            globalSearch: true,
            notification: true,
            employeeJourney: true,
            virtualAssistant: true,
            positionAndJobRequisitionCreation: true,
            myTeam: true,
            hrServices: true,
            annualClockManagerView: false,
        };
    }

    if (!profile) {
        return {
            globalSearch: false,
            notification: false,
            employeeJourney: false,
            virtualAssistant: isAdmin,
            positionAndJobRequisitionCreation: isAdmin,
            myTeam: false,
            hrServices: false,
            annualClockManagerView: false,
        };
    }

    return {
        globalSearch: false,
        notification: false,
        employeeJourney: true,
        virtualAssistant: true,
        positionAndJobRequisitionCreation: isAdmin || !!profile.isManager,
        myTeam: isAdmin || !!profile.isManager,
        annualClockDisplay: false,
        hrServices: false,
        //HR will also see the both Manager and Employee tabs in Annual Clock.
        annualClockManagerView:
            profile.businessFunction === BusinessFunction.HumanResources ||
            profile.businessUnit === BusinessUnit.HumanResources ||
            profile.businessUnit === BusinessUnit.HrInternalCommunications,
    };
}

export const useFeatureFlags = () => {
    const isProd = getIsProd();
    const { isAdmin } = useAdUser();
    const profile = useSelector((state) => state.user.profile.data);

    return generateFeatureFlags(isProd, isAdmin, profile);
};
